export const vitalFields = [
  { label: 'BP', key: 'bp' },
  { label: 'Temp', key: 'temp' },
  { label: 'HR', key: 'hr' },
  { label: 'RR', key: 'rr' },
  { label: 'WT', key: 'wt' },
  { label: 'HT', key: 'ht' },
  { label: 'BMI', key: 'bmi' }
];

export const providerOptions = [
  { value: 10, label: 'John Smith' },
  { value: 20, label: 'John Doe' },
  { value: 30, label: 'Mary Smith' }
];

export const initialVitals = {
  bp: '',
  temp: '',
  hr: '',
  rr: '',
  wt: '',
  ht: '',
  bmi: ''
};

export const initialSoapText = {
  Subjective: '',
  Objective: '',
  AssessmentPlan: ''
};